import styled, { css } from "styled-components";
import { IQuickButtonsStyleProps } from "./interfaces";

export const StyledTaskCard = styled.div`
    background-color: ${p => p.theme.c.cardBackground};
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    margin: 12px 0 20px;
    position: relative;
    display: flex;
    align-items: center;
    transition: 300ms;

    ${p =>
        p.theme.sm.max(css`
            flex-direction: column;
            align-items: flex-start;
        `)}

    &.Hover {
        box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow4};
        ${p =>
            p.theme.md.min(css`
                transform: scale(0.992);
            `)}
    }
`;

export const ArrowButton = styled.button`
    width: 40px;
    height: 40px;
    position: absolute;
    right: 24px;
    transition: 0.1s;
    padding: 0;
    margin: 0;
    box-sizing: content-box;
    cursor: pointer;
    .i-arrowup {
        display: block;
        font-size: 40px;
    }

    @media (max-width: 460px) {
        width: 32px;
        height: 32px;
        .i-arrowup {
            font-size: 32px;
        }
    }

    @media (max-width: 460px) {
        right: 10px;
    }
`;

export const ArrowButtonUp = styled(ArrowButton)`
    top: 24px;
    @media screen and (max-width: 460px) {
        top: calc(100% - 86px);
    }
`;

export const ArrowButtonDown = styled(ArrowButton)`
    top: 86px;
    transform: scale(1, -1);

    @media screen and (max-width: 460px) {
        top: calc(100% - 42px);
    }
`;

export const StyledIcon = styled.div`
    margin-left: 48px;
    div,
    svg {
        display: block;
    }
    ${p =>
        p.theme.md.only(css`
            margin-left: 32px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            margin-left: 12px;
            margin-top: 12px;
            margin-bottom: 12px;
        `)}
`;

export const TaskPreview = styled.div`
    width: 270px;
    position: relative;

    > div:first-child {
        border-radius: 4px 0 0 4px;
        overflow: hidden;
    }

    ${p =>
        p.theme.sm.max(css`
            width: 320px;
        `)}

    @media screen and (max-width: 375px) {
        width: 100%;
    }
`;

export const EmptyCard = styled.div`
    width: 270px;
    background-color: ${p => p.theme.c.white};
`;

export const Separator = styled.div`
    width: 18px;
    left: 270px;
    position: absolute;
    height: 100%;
    background-color: ${p => p.theme.c.info};

    ${p =>
        p.theme.sm.max(css`
            display: none;
        `)}
`;

export const QuickButtons = styled.div<IQuickButtonsStyleProps>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${p => p.theme.c.blackShadow3};
    opacity: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: 300ms;

    a {
        margin: 12px;
        cursor: pointer;

        [class^="i-"] {
            fill: ${p => p.theme.c.whiteOnActive};
            color: ${p => p.theme.c.whiteOnActive};
            font-size: 60px;
            display: inline-block;
            transition: 300ms;
        }
        &:hover {
            [class^="i-"] {
                transform: scale(1.24);
            }
        }
    }
    border-radius: 4px 0 0 4px;
    ${p =>
        p.parentHover
            ? css`
                  opacity: 1;
                  background-color: ${p => p.theme.c.blackShadow35};
                  border-radius: 4px 0 0 4px;
              `
            : undefined}
`;

export const TaskTypeWrapper = styled.div`
    margin-left: 24px;
    display: inline-block;
    position: relative;

    ${p =>
        p.theme.md.only(css`
            margin-left: 18px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            position: absolute;
            top: 212px;
            left: 80px;
        `)}

    ${p =>
        p.theme.xs(css`
            width: calc(100% - 150px);
            top: calc(100% - 96px);
            display: flex;
            align-items: center;
            height: 96px;
        `)}

`;

export const TaskType = styled.h4`
    font-size: 22px;
    font-weight: 600;
    color: ${p => p.theme.c.boost};
    margin: 0;
    display: flex;
    align-items: center;

    ${p =>
        p.theme.md.only(css`
            font-size: 18px;
        `)}

    ${p =>
        p.theme.xs(css`
            font-size: 18px;
        `)}
`;

export const Alert = styled.div`
    position: absolute;
    top: 100%;
    cursor: pointer;
    .i-alert {
        margin-top: 3px;
        margin-left: -3px;
        color: ${p => p.theme.c.info};
        display: block;
        font-size: 17px;
    }

    .Tooltip {
        opacity: 0;
        pointer-events: none;
        transition: 300ms;
        position: absolute;
        z-index: 2;
        width: 210px;
        top: 4px;
        left: 26px;
        font-size: 16px;
        font-weight: 300;
        font-variant: normal;
        color: white;
        text-shadow: 0 0 3px ${p => p.theme.c.blackShadow4};
        border-radius: 5px;
        padding: 6px 10px;
        line-height: 1.5;
        background-color: ${p => p.theme.c.info};
        text-align: justify;
    }

    ${p =>
        p.theme.xs(css`
            top: -2px;
            position: relative;
            margin-left: 8px;
            .Tooltip {
                display: none;
            }
        `)}
    ${p =>
        p.theme.sm.min(css`
            &:hover {
                .Tooltip {
                    opacity: 1;
                }
            }
        `)}
`;

export const Generate = styled.span`
    display: inline-block;
    margin-left: 4px;
    .i-generate,
    .i-messages {
        font-size: 38px;
        color: ${p => p.theme.c.active};
        display: block;
    }

    @media (max-width: 460px) {
        .i-generate,
        .i-messages {
            font-size: 28px;
            display: block;
        }
        position: absolute;
        right: -36px;
        top: -41px;
        background: white;
        border-radius: 30px;
        padding: 3px;
        box-shadow: 0 0 3px 0 ${p => p.theme.c.blackShadow1};
    }
`;

export const Description = styled(Generate)`
    @media (min-width: 461px) {
        transform: translateY(3px);
    }

    &.NextToGenerate {
        right: 8px;
    }
`;
